import React from 'react';
import './ProfilePreviewScreen.css';

const ProfilePreviewScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="profile-preview-screen">
      <h1>Profile Preview</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default ProfilePreviewScreen; 